// extracted by mini-css-extract-plugin
export default {"start_page":"StartPage_start_page__g6hyJ"};